export default function renderBarStatus(status) {
  switch (status) {
    case 0:
      return (
        <div className="order-label">
          <span className="label-new">New</span>
        </div>
      );
    case 1:
      return (
        <div className="order-label">
          <span className="label-supervisor">Supervisor Approved</span>
        </div>
      );
    case 2:
      return (
        <div className="order-label">
          <span className="label-pcard">PCard Approved</span>
        </div>
      );
    case 3:
      return (
        <div className="order-label">
          <span className="label-hold">On Hold</span>
        </div>
      );
    case 4:
      return (
        <div className="order-label">
          <span className="label-assist-requested">Assistance Requested</span>
        </div>
      );
    case 5:
      return (
        <div className="order-label">
          <span className="label-assist-approval">Assistance Approved</span>
        </div>
      );
    case 6:
      return (
        <div className="order-label">
          <span className="label-ordered">Ordered</span>
        </div>
      );
    case 7:
      return (
        <div className="order-label">
          <span className="label-shipped">Shipped</span>
        </div>
      );
    case 8:
      return (
        <div className="order-label">
          <span className="label-delivering">Out for Delivery</span>
        </div>
      );
    case 9:
      return (
        <div className="order-label">
          <span className="label-delivered">Delivered</span>
        </div>
      );
    case 10:
      return (
        <div className="order-label">
          <span className="label-denied">Denied</span>
        </div>
      );
    case 11:
      return (
        <div className="order-label">
          <span className="label-order-cancelled">Cancelled</span>
        </div>
      );
    case 12:
      return (
        <div className="order-label">
          <span className="label-stockout">Out of Stock</span>
        </div>
      );
    case 13:
      return (
        <div className="order-label">
          <span className="label-edited">Order Edited</span>
        </div>
      );
    case 14:
      return (
        <div className="order-label">
          <span className="label-edited">Order Processing</span>
        </div>
      );
    default:
      return null;
  }
}
export const renderStatus = (status) => {
  switch (status) {
    case 0:
      return <span className="label label-new">New</span>;
    case 1:
      return (
        <span className="label label-supervisor">Supervisor Approved</span>
      );
    case 2:
      return <span className="label label-pcard">PCard Approved</span>;
    case 3:
      return <span className="label label-hold">On Hold</span>;
    case 4:
      return (
        <span className="label label-assist-requested">
          Assistance Requested
        </span>
      );
    case 5:
      return (
        <span className="label label-assist-approval">Assistance Approved</span>
      );
    case 6:
      return <span className="label label-ordered">Ordered</span>;
    case 7:
      return <span className="label label-shipped">Shipped</span>;
    case 8:
      return <span className="label label-delivering">Out for Delivery</span>;
    case 9:
      return <span className="label label-delivered">Delivered</span>;
    case 10:
      return <span className="label label-denied">Denied</span>;
    case 11:
      return <span className="label label-order-cancelled">Cancelled</span>;
    case 12:
      return <span className="label label-stockout">Out of Stock</span>;
    case 13:
      return <span className="label label-edited">Order Edited</span>;
    case 15:
      return <span className="label label-processing">Order Processing</span>;
    default:
      return null;
  }
};

export function renderUrgency(urgency) {
  switch (urgency) {
    case 0:
      return <span className="label label-danger">High</span>;
    case 1:
      return <span className="label label-warning">Standard</span>;
    case 2:
      return <span className="label label-info">Low</span>;
    default:
      return null;
  }
}
